import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      const u = await login(email, password);
      nav(u.role === "admin" ? "/admin" : "/account");
    } catch (e) {
      setErr(e.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 min-h-[70vh]">
      <div className="hidden md:flex flex-col justify-between p-12 border-r border-zinc-900 bg-zinc-900 text-white relative noise">
        <div>
          <div className="text-xs uppercase tracking-widest font-[Outfit] font-bold opacity-70">Stuffly</div>
          <h1 className="text-5xl font-black tracking-tighter uppercase mt-4 font-[Outfit] leading-[0.9]">Welcome<br />Back.</h1>
        </div>
        <p className="text-sm opacity-80">Log in to track your orders, save addresses, and check out faster.</p>
      </div>
      <form onSubmit={submit} className="p-8 md:p-12 flex flex-col justify-center">
        <div className="tag mb-4">Login</div>
        <h2 className="text-3xl font-black tracking-tighter uppercase font-[Outfit]">Access Account</h2>
        <div className="mt-6 space-y-4">
          <div>
            <label className="text-xs uppercase tracking-widest font-bold font-[Outfit] block mb-2">Email</label>
            <input data-testid="login-email" type="email" required className="input-brutal" value={email} onChange={e => setEmail(e.target.value)} />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest font-bold font-[Outfit] block mb-2">Password</label>
            <input data-testid="login-password" type="password" required className="input-brutal" value={password} onChange={e => setPassword(e.target.value)} />
          </div>
          {err && <div data-testid="login-error" className="border border-[#ff3333] bg-[#fff3f3] px-3 py-2 text-sm text-[#cc0000] font-bold uppercase tracking-wider font-[Outfit]">{err}</div>}
          <button data-testid="login-submit" disabled={loading} className="btn-brutal btn-red w-full">{loading ? "..." : "Log In →"}</button>
          <div className="text-sm text-zinc-600">No account? <Link to="/register" className="underline font-bold">Create one</Link></div>
        </div>
      </form>
    </div>
  );
}
